export default "__VITE_ASSET__Un4nVRI5__"